/* eslint-disable no-unused-vars */

/**
 * Creates an instance of QuestionFormFieldValidation.
 * @typedef {Object} QuestionFormFieldValidationType
 * @property {?boolean} required
 * @property {?number} minLength
 * @property {?number} maxLength
 * @property {?number} minValue
 * @property {?number} maxValue
 * @property {?string} pattern - Regex pattern
 * @property {?number} integer
 */

/**
 * Represents a question form field validation.
 * @class
 */
export class QuestionFormFieldValidation {
  /**
   * Create a new QuestionFormFieldValidation.
   * @param {QuestionFormFieldValidationType} params
   */
  constructor(params) {
    this.id = params.id
    this.fieldType = params.fieldType
    this.key = params.key
    this.label = params.label
    this.description = params.description
  }
}
